import PageSelector from './PageSelector'

export default PageSelector
